import script from "./Link.vue?vue&type=script&setup=true&lang=js"
export * from "./Link.vue?vue&type=script&setup=true&lang=js"

import "./Link.vue?vue&type=style&index=0&id=53b4ae4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b4ae4a"]])

export default __exports__